import { User } from "@ecologi/shared";
import styled from "@emotion/styled";
import { useRouter } from "next/router";
import { Button } from "../../Button";
import { TuftyButton } from "../../Button/TuftyButton";

type Props = {
  setDonateModalState: (state: boolean) => void;
  setAlbertModalState: (state: boolean) => void;
  isOwnProfile: boolean;
  isTreeMode: boolean;
  isBulkParent?: boolean;
  user?: User | null;
};

export const BespokeBaftaAlbertWrapper = styled.div`
  display: block;
  margin-top: 24px;
`;

export const BespokeNetZeroSessionsWrapper = styled.div`
  display: block;
  margin: 15px auto 0;
`;

export const DonationButton = ({
  setDonateModalState,
  setAlbertModalState,
  isOwnProfile,
  isTreeMode,
  isBulkParent, // bespoke for albert
}: Props) => {
  const lastWord = isTreeMode ? "trees" : "impact";
  let text = isOwnProfile ? `Buy more ${lastWord}` : `Gift more ${lastWord}`;
  const router = useRouter();

  // Bespoke for bafta/albert client
  if (isOwnProfile && isBulkParent) {
    return (
      <BespokeBaftaAlbertWrapper>
        <Button
          primary
          text="Request Impact"
          onClick={() => {
            setAlbertModalState(true);
          }}
        />
      </BespokeBaftaAlbertWrapper>
    );
  }

  return (
    <TuftyButton
      primary
      extra={{
        style: {
          display: "block",
          margin: "15px auto 0",
        },
      }}
      onClick={(e) => {
        e.preventDefault();
        if (e.currentTarget instanceof HTMLElement) {
          e.currentTarget.blur();
        }

        if (isOwnProfile) {
          router.push("/impact-shop");
          return;
        }

        setDonateModalState(true);
      }}
      text={text}
    />
  );
};
